import apiUrl from '../../../constants';
import axios from 'axios';
//import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import download from 'downloadjs';
import Pagination from './../shared/pagination'
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import JsonExcel from "vue-json-excel";
import Vue from "vue";
import csvHelper from '../reports/importjsontocsv';
Vue.component("downloadExcel", JsonExcel);


export default {
    name: 'merchant',
    components: {
        //Paginate,
        BasicSelect,
        Pagination,
        Loader,
        DatePicker,
        JsonExcel,
        download,
    },
    data: function () {
        return {
            formattedDate: '',
            currentPage: 1,
            totalPage: 0,
            totalCount: 0,
            pageLimit: 10,
            showSelectWarehouse: false,
            isLoading: false,
            showSelectClient: false,
            searchFlag1: false,
            searchFlag: false,
            processstatus: '',
            checkstatus: '',
            listWarehouseData: [],
            listClientData: [],
            listProductRackData: [],
            listMerchantData: [],
            fromdate: '',
            todate: '',
            warehouse: '',
            rto_srid: '',
            Merchant: '',
            WarehouseErr: '',
            MerchantErr: '',
            warehouseid: '',
            user_type: '',
            client: '',
            racktype: '',
            clientid: '',
            ClientErr: '',
            lineno: '',
            rackno: '',
            sectionid: '',
            listProductRackDataCsv: '',
            processstatusarr: ['RVP', 'RTO'],
            userid: '',
            rackuti: '',
            rtoid: '',
            listReportDataforxls: [],
            csvFieldsForXls: {},
            reportname: '',
            show: '',
            limitExeed: '',
            download: true,
            listshippingcompanyData: [],
            couriername: '',
            awbno: '',
            stocktype: '',
            stocktypeErr: '',
            errormsg: false,
            ps: ''
        }
    },
    filters: {
        moment: function (date) {
            if (date)
                return moment(date).format('DD-MM-YYYY HH:mm:ss');
            else {
                return '';
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },

    mounted() {
        var today = new Date();
        this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        // this.getProductRackDatasearch();
        this.useremail = userdetail.email;
        var loginuseremail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        //  this.warehouse = userdetail.warehouseid;
        this.clientid = userdetail.clientid;
        this.loginClientUserId = userdetail.clientid;
        this.loginuserid = userdetail.userid;
        this.userid = userdetail.userid;
        this.user_type = userdetail.utype;

        this.reportname = this.$t('rejectlistrto.notOurproduct')
        this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
        switch (this.user_type) {
            case 'system_user':

                this.showSelectWarehouse = true;
                this.showSelectClient = true;
                this.showSelectMerchant = true;
                // this.getWarehouseList();
                // this.getClientList();
                // this.getProductRackData();
                break;

            case 'warehouse_user':
                this.loginUserEmail = userdetail.email;
                this.warehouse = userdetail.warehouseid;
                this.warehouseid = userdetail.warehouseid;
                this.showSelectClient = true;
                this.showSelectMerchant = true;
                // this.getClientList();
                this.getProductRackData();
                break;

            default:
                this.$alertify.error("Unauthorised user, Please contact your system admin");
                break
        }
    },
    methods: {
        filters: {
            moment: function (date) {
                if (!date) return '';
                return moment(date).format('DD-MM-YY hh:mm:ss');
            }
        },
        jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter = []) {

            var csvData = '';
            //Header
            if (this.title != null) {
                csvData += this.parseExtraData(this.title, '${data}\r\n')
            }
            csvData += ''
            Object.entries(dataFilter).forEach(([k, v]) => {
                csvData += k + ':' + v + ','
            })
            csvData += '\r\n'
            csvData += '\r\n'
            //Fields
            for (let key in data[0]) {
                if (skipFilter.indexOf(key) == -1)
                    csvData += csvfield[key] + ',';
            }
            csvData = csvData.slice(0, csvData.length - 1);
            csvData += '\r\n';
            //Data
            data.map(function (item) {
                for (let key in item) {
                    if (skipFilter.indexOf(key) == -1) {
                        var escapedCSV = item[key] + ''; // cast Numbers to string
                        if (escapedCSV.match(/[,"\n]/)) {
                            escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
                        }
                        if (escapedCSV == 'null')
                            csvData += ',';
                        else {
                            if (dateFilter.indexOf(key) != -1)
                                csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
                            else
                                csvData += escapedCSV + ',';
                        }
                    }
                }
                csvData = csvData.slice(0, csvData.length - 1);
                csvData += '\r\n';
            })
            //Footer
            if (this.footer != null) {
                csvData += this.parseExtraData(this.footer, '${data}\r\n');
            }
            filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
            return this.export(csvData, filename, "application/csv");
            return csvData;
        },

        export(data, filename, mime) {
            let blob = this.base64ToBlob(data, mime);
            download(blob, filename, mime);
        },

        base64ToBlob(data, mime) {
            let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
            let bstr = atob(base64);
            let n = bstr.length;
            let u8arr = new Uint8ClampedArray(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            })
        },
        getNotinPOReportserach() {
            this.currentPage = 1;
            this.searchFlag = true;
            this.getNotinPOReportData(2)
        },
        checkinput() {
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            this.pageno = 0;
            if (this.showSelectWarehouse == true) {
                this.warehouseid = this.warehousename
            }
            this.input = ({
                awbno: this.awbno,
                warehouse: localStorage.getItem("selectedWarehouse"),
                //   couriername:this.couriername
            });
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'checknopawbno',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
                .then(result => {
                    if (result.data.errorCode == -1) {
                        this.errormsg = true;
                        this.msg = result.data.msg;
                    } else {
                        this.errormsg = false;
                    }
                }, error => {
                    console.error(error);
                });
        },
        // getClientList() {
        //     if (window.localStorage.getItem("clientList") !== null) {
        //         var clientListEncrypt = window.localStorage.getItem('clientList');
        //         var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        //         var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        //         this.listClientData = JSON.parse(plaintextclient);
        //     }
        //     else {
        //         var userToken = window.localStorage.getItem('userToken');
        //         var myStr = userToken.replace(/"/g, '');
        //         this.pageno = this.totalPage = 0;

        //         if (this.warehouseid)
        //             this.input = ({
        //                 warehouseid: this.warehouseid,
        //             });
        //         else {
        //             this.input = {};
        //         }
        //         axios({
        //             method: 'POST',
        //             'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
        //             'data': this.input,
        //             headers: {
        //                 'Authorization': 'Bearer ' + myStr,
        //             }
        //         })
        //             .then(result => {
        //                 this.listClientData = result.data.data;

        //             }, error => {
        //                 console.error(error);
        //             });
        //     }
        // },


        // getWarehouseList() {
        //     var userToken = window.localStorage.getItem('userToken')
        //     var myStr = userToken.replace(/"/g, '');
        //     this.pageno = 0;
        //     this.input = ({
        //         'clientid': this.client,
        //     });
        //     axios({
        //         method: 'POST',
        //         'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
        //         'data': this.input,
        //         headers: {
        //             'Authorization': 'Bearer ' + myStr
        //         }
        //     })
        //         .then(result => {
        //             this.listWarehouseData = result.data.data;
        //         }, error => {
        //             console.error(error)
        //         })
        // },
        // clientSelected() {
        //     //  console.log("slee")
        //     if (this.clientid != this.client || this.clientid == this.client) {
        //         this.clientid = this.client;
        //         if (this.user_type != 'warehouse_user') {
        //             this.listWarehouseData = []
        //             this.getWarehouseList();

        //             if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
        //                 this.warehouse = this.warehouseid = '';
        //             } else {
        //                 //this.merchantList=[]
        //                 this.warehouse = ''

        //             }
        //         } else {

        //             this.getshippingData();
        //         }
        //     }
        //     this.listRackinData = [];
        //     this.pageno = this.totalPage = 0;
        //     this.rackuti = ''
        // },

        getshippingData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
                clientid: this.client,
                warehouseid: localStorage.getItem("selectedWarehouse"),
            })
            axios({

                method: 'POST',
                'url': apiUrl.api_url + 'shippingDetails',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    this.listshippingcompanyData = result.data.data
                }, error => {
                    console.error(error)
                })
        },

        // warehouseSelected() {
        //     this.warehouseid = this.warehouse;
        //     this.pageno = this.totalPage = 0;
        //     if (this.warehouseid) {
        //         if (this.clientid) {
        //             this.getshippingData();
        //             // this.getProductRackData();
        //         } else {
        //             this.getshippingData();
        //         }
        //     }
        // },
        startDownload() {
            this.isLoadingforxls = true;
        },
        finishDownload() {
            this.isLoadingforxls = false;
        },
        Choosetype() {
            this.show = true;
            this.download = false;
            if (!this.limitExeed) {
                this.getAuditListForXLS(3)
            }
        },
        getAuditListForXLS(csvCheck = 0) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            //console.log("in csv3")
            var dataFilter = {};
            this.show = true;
            this.download = false;
            this.dataFilter2 = [];
            var value = '';
            var str = '';


            this.input = ({
                limit: this.pageLimit,
                offset: (this.currentPage - 1) * 10,
                warehouseid: localStorage.getItem("selectedWarehouse"),
                clientid: this.client,
                awbno: this.awbno,
                rto_srid: this.rto_srid,
                couriername: this.couriername,
                processstatus: this.processstatus
            });
            Object.entries(this.input).forEach(([k, v]) => {
                let skipkeys = ['offset', 'limit', 'csvData'];
                if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
                    value += k + ':' + v + ','
                    this.dataFilter2 = str.concat(value);

                }
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getNotOurProducts',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    if (csvCheck == 3) {
                        if (result.data.count) {
                            this.listReportDataforxls = [];
                            if (this.checkstatus == 'RVP') {
                                this.csvFieldsForXls[this.$t('common.id')]='id'
                                this.csvFieldsForXls[this.$t('client.clientName')]='warehousename'
                                this.csvFieldsForXls[this.$t('common.description')]='description'
                                this.csvFieldsForXls[this.$t('common.createdDateTime')]='createddatetime'
                                this.csvFieldsForXls[this.$t('rejectlistrto.nopId')]='nopid'
                                this.csvFieldsForXls[this.$t('rejectlistrto.rvpId')]='srid'
                                this.csvFieldsForXls[this.$t('rejectlistrto.awbNo')]='awbno'
                            } else if (this.checkstatus == 'RTO') {
                                this.csvFieldsForXls[this.$t('common.id')]='id'
                                this.csvFieldsForXls[this.$t('client.clientName')]='warehousename'
                                this.csvFieldsForXls[this.$t('common.description')]='description'
                                this.csvFieldsForXls[this.$t('common.createdDateTime')]='createddatetime'
                                this.csvFieldsForXls[this.$t('rejectlistrto.nopId')]='nopid'
                                this.csvFieldsForXls[this.$t('rejectlistrto.rtoId')]='rtoid'
                                this.csvFieldsForXls[this.$t('rejectlistrto.awbNo')]='awbno'
                            }

                            this.listReportDataforxls = result.data.data;
                        } else {
                            if (result.data.status == true) {
                                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
                            } else {
                                this.$alertify.error(result.data.msg.message);
                            }
                        }
                    }

                }, error => {
                    console.error(error);
                })
        },


        dateFormat(date) {
            if (!date) return '';
            return moment(date).format('YYYY-MM-DD');
        },
        dateFormatFRT(date) {
            if (!date) return '';
            return moment(date).format('DD-MM-YY HH:mm:ss');
        },
        // get Product Rack list
        getNotinPOReportData(csvCheck = 0) {

            if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            this.isLoading = true;
            var fr_date = '';
            var to_date = '';

            if (this.fromdate) {
                fr_date = this.dateFormat(this.fromdate)
            }
            if (this.todate) {
                to_date = this.dateFormat(this.todate)
            }
            var dataFilter = {};



            this.input = ({
                limit: this.pageLimit,
                fromdate: fr_date,
                todate: to_date,
                offset: (this.currentPage - 1) * 10,
                warehouseid: localStorage.getItem("selectedWarehouse"),
                clientid: this.client,
                awbno: this.awbno,
                rto_srid: this.rto_srid,
                couriername: this.couriername,
                // processstatus:this.processstatus
            });
            if (csvCheck == 2) {
                this.show = false;
                this.searchFlag1 = true;
                this.download = true;
                this.currentPage = 1;
                this.input.processstatus = this.processstatus
                this.ps = this.processstatus
            }
            if (csvCheck != 2) {
                this.input.processstatus = this.ps
            }
            Object.entries(this.input).forEach(([k, v]) => {
                let skipkeys = ['offset', 'limit', 'csvData'];
                if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
                    dataFilter[k] = v;
                }
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getNotOurProducts',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
                .then(result => {
                    this.searchFlag = true;

                    if (csvCheck == 1) {
                        if (result.data.count > 0) {
                            this.listProductRackDataCsv = [];
                            this.csvFields = {
                                'id': this.$t('common.id'),
                                'warehousename': this.$t('warehouses.warehouseName'),
                                'clientname':  this.$t('client.clientName'),
                                'description': this.$t('common.description'),
                                'nopid': this.$t('rejectlistrto.nopId'),
                                'returnstatus': this.$t('rejectlistrto.returnStatus'),
                                'saleschannel': this.$t('common.salesChannel'),
                                'orderid': this.$t('common.orderID'),
                                'productid': this.$t('common.productId'),
                                'createdby': this.$t('common.createdBy'),
                                'createddatetime':  this.$t('common.createdDateTime'),
                                'image1': this.$t('rejectlistrto.image1'),
                                'image2': this.$t('rejectlistrto.image2'),
                                'image3': this.$t('rejectlistrto.image3'),
                                'rtoid': this.$t('rejectlistrto.rtoId'),
                                'srid':this.$t('rejectlistrto.rvpId'),
                                'awbno': this.$t('rejectlistrto.awbNo'),
                                'couriercompany':  this.$t('common.courierCompany'),
                            };
                            var dateFilter = [];
                            if (this.checkstatus == 'RTO') {
                                var skipFilter = ['image1', 'warehouseid', 'couriercompany', 'clientid', 'image2', 'image3', 'createdby', 'coverimage', 'srid'];
                            } else if (this.checkstatus == 'RVP') {
                                var skipFilter = ['image1', 'warehouseid', 'couriercompany', 'clientid', 'image2', 'image3', 'createdby', 'coverimage', 'rtoid'];
                            }
                            this.listProductRackDataCsv = result.data.data;
                            csvHelper.data.jsonToCSV(this.$t('rejectlistrto.notOurproduct'), this.listProductRackDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);
                        }
                        else {

                            if (result.data.status == true) {
                                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
                            }
                            else if (result.data.data.length == true) {
                                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
                            }
                            else {
                                this.$alertify.error(result.data.msg.message);
                            }
                        }
                    } else {
                        if (result.data) {
                            this.checkstatus = result.data.processtype
                            this.listProductRackData = result.data.data;
                            this.totalCount = result.data.count
                            this.resultCount = result.data.count;
                            if (this.totalCount < 10) {
                                this.totalPage = 1
                            } else {
                                this.totalPage = Math.ceil(this.totalCount / 10);
                            }
                        }
                        else {
                            this.isLoading = false;
                            this.listProductRackData = []
                        }
                        // this.totalRows = result.data.count;
                        // this.resultCount = result.data.count
                        // if (this.totalRows < this.perPage) {
                        //  this.pageCount = 1;
                        // } else {
                        //  this.pageCount = Math.ceil(this.totalRows / this.perPage);
                        // }

                    }
                    this.isLoading = false;
                },
                    error => {
                        console.error(error);
                    })
        },

        //for search filter make offset 0
        getProductRackDatasearch() {
            this.currentPage = 1;
            this.totalPage = 0;
            this.searchFlag = true;
            this.getProductRackData(2);
        },

        //Call page number from pagination
        // getPaginationData(currentPage) {
        //  this.pageno = (currentPage - 1) * this.perPage;
        //  this.getProductRackData();
        // },
        onPageChange(page) {
            this.currentPage = page;
            this.getNotinPOReportData()
        },

        //Reset the Search filter
        resetForm() {
            this.totalCount = 0;
            this.processstatus = '',
                this.awbno = '',
                this.couriername = '',
                this.rto_srid = '',
                this.fromdate = '',
                this.todate = '',
                this.searchFlag = false
            this.errormsg = ''
            this.listProductRackData = [];
            this.$validator.reset();
            if (this.user_type == 'warehouse_user')
                this.clientAA = '';
            else if (this.user_type == 'client_user')
                this.warehouse = '';
            else {
                // this.clientaaa = '';
                this.warehouse = '';
            }
            // this.getWarehouseList();
        },
        async validatevalues() {
            try {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.getNotinPOReportData(2);
                    } else {
                        console.log("not valid")
                    }
                })
            }
            catch (err) {
                this.isLoading = false;
                this.$alert(err, "", "error");
                console.log(err);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/notourproduct/notourproduct.component.js